import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AccessDeniedCard from '../../../components/AccessDeniedCard';
import { canAccessSettings } from '../../../utils/roles';

export default function SettingsAccessLayout() {
  const user = useSelector((state) => state.user.user);
  const loading = useSelector((state) => state.user.loading);

  if (loading) {
    return null;
  }

  if (!canAccessSettings(user)) {
    return <AccessDeniedCard title="Settings" />;
  }

  return <Outlet />;
}
